module.exports = __webpack_public_path__ + "img/razzo.1905d4ae.webp";